<div class="tab-container">

    <div class="g_foto-boxes-container top-photos-container">
        <app-image-input
                label="Heizkeller 1*"
                name="pre_install_boiler_room_image_1"
                required
                [(ngModel)]="model.preInstallBoilerRoomImages[0].image">
        </app-image-input>

        <app-image-input
                label="Heizkeller 2*"
                name="pre_install_boiler_room_image_2"
                required
                [(ngModel)]="model.preInstallBoilerRoomImages[1].image">
        </app-image-input>

        <app-image-input
                label="Heizkeller 3*"
                name="pre_install_boiler_room_image_3"
                required
                [(ngModel)]="model.preInstallBoilerRoomImages[2].image">
        </app-image-input>
    </div>

    <div class="g_foto-boxes-container top-photos-container">
        <ng-container *ngFor="let image of model.preInstallHeatingImages, let i = index">
            <app-image-input *ngIf="i === 0"
                             [label]="'Foto Steuerung ' + (i + 1) + '*'"
                             [name]="'pre_install_heating_image_' + (i + 1)"
                             [(ngModel)]="image.image"
                             required
                             (ngModelChange)="updateHeatingImages($event, i)">
            </app-image-input>
            <app-image-input *ngIf="i !== 0"
                             [label]="'Foto Steuerung ' + (i + 1)"
                             [name]="'pre_install_heating_image_' + (i + 1)"
                             [(ngModel)]="image.image"
                             (ngModelChange)="updateHeatingImages($event, i)">
            </app-image-input>
        </ng-container>
    </div>
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/general/gateway'"
        [isNextLinkDisabled]="!validationService.isGeneralPrePhotosValid(model)"
        [nextLink]="'/gateway/general/measurement'"
        [isLast]="false"
></app-navigation-footer>
